export default function SummerCamps() {
	return (
		<div className="relative isolate min-h-screen overflow-hidden bg-stone-900 pb-24">
			<div className="mx-auto mt-24 max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
			</div>
			<div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
				<div className="flex items-center">
					<div className="flex-auto">
						<h2 className="text-base font-semibold uppercase tracking-wide text-stone-200">
							2026
						</h2>
						<h3 className="mt-2 text-3xl font-extrabold leading-8 text-stone-50 sm:text-4xl">
							Summer Camps
						</h3>
						{/* <p className="mt-2 text-sm text-stone-300">
							Classes run from June 17, 2025 to August 15, 2025.
						</p> */}
					</div>
				</div>
				<div className="mt-8 rounded-lg border border-[#f9c04d] px-6 py-6 sm:px-8">
					<div className="mx-auto max-w-2xl text-center">
						<h2 className="p-4 text-2xl font-bold tracking-tight text-stone-100 sm:text-4xl">
						Wicked Camp
						</h2>
						<div className="h-1 border-t border-stone-600" />
						<p className="pt-2 text-[#f9c04d]">(Ages 3 - 8)</p>
						<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
							Join us for Oz-some dancing, singing, crafting and more with music
							from Wicked, The Wizard of Oz & The Wiz!
						</p>
					</div>
					<div className="mx-auto mt-8 w-full max-w-sm border-t border-stone-600 font-bold">
						<dl className="divide-y divide-stone-600">
							<div className="grid grid-cols-2 gap-4 py-4">
								<dt className="text-sm text-stone-50">
									June 15 - June 18, 2026
								</dt>
								<dt className="text-sm text-stone-50">9:30 am - 12:00 pm</dt>
							</div>
							<div className="grid grid-cols-2 gap-4 py-4">
								<dt className="col-span-2 text-center text-sm text-stone-50">
									Full Week: $175
								</dt>
							</div>
						</dl>
					</div>
				</div>
				<div className="mt-8 rounded-lg border border-[#f9c04d] px-6 py-6 sm:px-8">
					<div className="mx-auto max-w-2xl text-center">
						<h2 className="p-4 text-2xl font-bold tracking-tight text-stone-100 sm:text-4xl">
							Pop Star Camp
						</h2>
						<div className="h-1 border-t border-stone-600" />
						<p className="pt-2 text-[#f9c04d]">(Ages 3 - 8)</p>
						<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
							Join us for a week of singing, dancing and crafting all to your
							favorite hits of the greatest pop stars of today!
						</p>
					</div>
					<div className="mx-auto mt-8 w-full max-w-sm border-t border-stone-600 font-bold">
						<dl className="divide-y divide-stone-600">
							<div className="grid grid-cols-2 gap-4 py-4">
								<dt className="text-sm text-stone-50">
									June 29 - July 2, 2025
								</dt>
								<dt className="text-sm text-stone-50">9:30 am - 12:00 pm</dt>
							</div>
							<div className="grid grid-cols-2 gap-4 py-4">
								<dt className="col-span-2 text-center text-sm text-stone-50">
									Full Week: $175
								</dt>
							</div>
						</dl>
					</div>
				</div>
			</div>
		</div>
	)
}
